export default __webpack_public_path__ + "static/industry-finance-9afc9dfd8e23c2b43ee97fb6f3991f6c.webp";